module.exports = __webpack_public_path__ + "img/comiru.1ed9bd1b.jpg";